export function getMediaUrl(media) {
  const damDownloadedContent = media?.damDownloadedContent?.url;
  const damContentSelector = media?.damContentSelector?.assetData[0]?.selectedImageUrl;
  return damDownloadedContent || damContentSelector;
}